import { createAction, props } from '@ngrx/store';
import {
  AgGridColumnSort,
  VehicleLicencesDto, LicenceDto, LicenceFromStoreOrderVehicleDto, LicenceProductCodeDto,
} from '@services/api/api.service';
import { Sort } from '@angular/material/sort';

export const setDataTrafficLicencesLoading = createAction(
  'setDataTrafficLicencesLoading',
  props<{ isLoading: boolean }>(),
);

export const setDataTrafficLicencesFilters = createAction(
  'setDataTrafficLicencesFilters',
  props<{ filters: { qSearch?: string, checkboxFilters?: { active?: boolean, expiring?: boolean, expired?: boolean }, sortModel?: AgGridColumnSort[], filterModel?: { [key: string]: any; } } }>(),
);

export const setDataTrafficLicencesPaginator = createAction(
  'setDataTrafficLicencesPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setDataTrafficLicencesList = createAction(
  'setDataTrafficLicencesList',
  props<{ response: VehicleLicencesDto[]; totalNumber: number }>(),
);

export const setDataTrafficLicencesAllData = createAction(
  'setDataTrafficLicencesAllData',
  props<{ allData: VehicleLicencesDto[] }>(),
);

export const getDataTrafficLicencesList = createAction(
  'getDataTrafficLicencesList',
);

export const getSnapshotDataTrafficLicencesList = createAction(
  'getSnapshotDataTrafficLicencesList',
);

export const setStoreOrderLicencesLoading = createAction(
  'setStoreOrderLicencesLoading',
  props<{ isLoading: boolean }>(),
);

export const setStoreOrderLicencesFilters = createAction(
  'setStoreOrderLicencesFilters',
  props<{ filters: { qSearch?: string, productCode?: string, checkboxFilters?: { active?: boolean, expiring?: boolean, expired?: boolean }, sortModel?: AgGridColumnSort[], filterModel?: { [key: string]: any; } } }>(),
);

export const setStoreOrderLicencesPaginator = createAction(
  'setStoreOrderLicencesPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setStoreOrderLicencesList = createAction(
  'setStoreOrderLicencesList',
  props<{ response: LicenceFromStoreOrderVehicleDto[]; totalNumber: number }>(),
);

export const setStoreOrderLicencesAllData = createAction(
  'setStoreOrderLicencesAllData',
  props<{ allData: LicenceFromStoreOrderVehicleDto[] }>(),
);

export const getStoreOrderLicencesList = createAction(
  'getStoreOrderLicencesList',
);

export const setSelectedDataTrafficLicenceLoading = createAction(
  'setSelectedDataTrafficLicenceLoading',
  props<{ isLoading: boolean }>(),
);

export const setSelectedDataTrafficLicenceFilters = createAction(
  'setSelectedDataTrafficLicenceFilters',
  props<{ filters: { qSearch?: string, sortModel?: AgGridColumnSort[], filterModel?: { [key: string]: any; } } }>(),
);

export const setSelectedDataTrafficLicencePaginator = createAction(
  'setSelectedDataTrafficLicencePaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setSelectedDataTrafficLicenceList = createAction(
  'setSelectedDataTrafficLicenceList',
  props<{ response: LicenceDto[] }>(),
);

export const getSelectedDataTrafficLicenceList = createAction(
  'getSelectedDataTrafficLicenceList',
  props<{ vin: string }>(),
);

export const setSelectedStoreOrderLicenceLoading = createAction(
  'setSelectedStoreOrderLicenceLoading',
  props<{ isLoading: boolean }>(),
);

export const setSelectedStoreOrderLicenceFilters = createAction(
  'setSelectedStoreOrderLicenceFilters',
  props<{ filters: { qSearch?: string, sortModel?: AgGridColumnSort[], filterModel?: { [key: string]: any; } } }>(),
);

export const setSelectedStoreOrderLicencePaginator = createAction(
  'setSelectedStoreOrderLicencePaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setSelectedStoreOrderLicenceList = createAction(
  'setSelectedStoreOrderLicenceList',
  props<{ response: LicenceFromStoreOrderVehicleDto }>(),
);

export const getSelectedStoreOrderLicenceList = createAction(
  'getSelectedStoreOrderLicenceList',
  props<{ vin: string }>(),
);

export const setLicenceProductCodesLoading = createAction(
  'setLicenceProductCodesLoading',
  props<{ isLoading: boolean }>(),
);

export const setLicenceProductCodesList = createAction(
  'setLicenceProductCodesList',
  props<{ productCodes: LicenceProductCodeDto[] }>(),
);

export const getLicenceProductCodes = createAction(
  'getLicenceProductCodes',
);
